import { getAuthState } from '../hooks/useAuth';

let auth = getAuthState();

export const generateLeadsAI = async (cnpjs_input: number[], leads: number, nome: string, weights: object, filters: object ): Promise<any> => {
    try {
        auth = getAuthState();

        const response = await fetch('https://f5gkmqm2yh.execute-api.us-east-1.amazonaws.com/prod/geracaoIA', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': auth.idToken
            },
            body: JSON.stringify({
                'cnpjs_input': cnpjs_input, 
                'leads': leads,
                'list_name': nome,
                "filtros": filters,
                "pesos": weights
            })
        });

        if (!response.ok) {
            throw new Error(`Erro HTTP! Status: ${response.status}`);
        }

        const data = await response.json();
        return data;

    } catch (error) {
        console.error('Error generating leads:', error);
        return [];
    }
};
